export default {"src":"/_next/static/media/logo_stroke.83dff415.svg","height":569,"width":951,"blurWidth":0,"blurHeight":0};